import { computed, ReadonlySignal } from '@preact/signals-react';
import { injectable } from 'inversify';

import { OperationResult } from '@vp/common/core/OperationResult';
import { AccessManagerPort } from '@vp/manager/access/core/interface/AccessManagerPort';
import { ApplyChangesUsecase } from '@vp/manager/access/core/usecase/ApplyChangesUsecase';
import { GenerateCodeUsecase } from '@vp/manager/access/core/usecase/GenerateCodeUsecase';
import { ProfileManagerState } from '@vp/manager/profile/core/interface/ProfileManagerState';
import { ProfileAccessModel } from '@vp/profile/core/model/ProfileAccessModel';

@injectable()
export class AccessManagerFacade implements AccessManagerPort {
  readonly access: ReadonlySignal<ProfileAccessModel> = computed(() => this.state.active.value?.access ?? new ProfileAccessModel());

  constructor(
    private readonly state: ProfileManagerState,
    private readonly applyChangesUsecase: ApplyChangesUsecase,
    private readonly generateCodeUsecase: GenerateCodeUsecase,
  ) {}

  async generateCode(): Promise<string> {
    return this.generateCodeUsecase.execute();
  }

  async apply(changes: ProfileAccessModel, controller?: AbortController): Promise<OperationResult> {
    return this.applyChangesUsecase.execute(changes, controller);
  }
}
